<app-mychart-web-header *ngIf="isMobileResolution==true"
    [firstName]="patientFirstName">
</app-mychart-web-header>
<div class="header-divider"></div>
<div class="get-care-now-background-mobile">
    <div class="bedside-survey-content">
        <h1 class="survey-title">{{ 'BEDSIDE_SURVEY.TITLE' | translate }}</h1>
        
        <p class="survey-description">
        {{ 'BEDSIDE_SURVEY.DESCRIPTION' | translate }}
        </p>

        <!-- Success Message -->
        <div *ngIf="submitSuccess" class="success-message">
            {{ 'BEDSIDE_SURVEY.SUCCESS_MESSAGE' | translate }}
        </div>

        <!-- Error Message -->
        <div *ngIf="submitError" class="error-message">
            {{ 'BEDSIDE_SURVEY.ERROR_MESSAGE' | translate }}
        </div>

        <div class="description-divider"></div>
        
        <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
        <!-- Patient Information Section -->
        <div class="patient-info-section">
            <h2 class="section-title">{{ 'BEDSIDE_SURVEY.PATIENT_INFO.TITLE' | translate }}</h2>
            
            <div class="form-group">
            <label class="form-label">{{ 'BEDSIDE_SURVEY.PATIENT_INFO.NAME_LABEL' | translate }} <span class="required-asterisk">*</span></label>
            <input 
                type="text"
                class="form-input"
                formControlName="patientName" 
                [placeholder]="'BEDSIDE_SURVEY.PATIENT_INFO.NAME_PLACEHOLDER' | translate">
            <!-- <div class="error-message" *ngIf="surveyForm.get('patientName')?.hasError('required') && surveyForm.get('patientName')?.touched">
                {{ 'BEDSIDE_SURVEY.VALIDATION.REQUIRED' | translate }}
            </div> -->
            </div>

            <div class="form-group">
            <label class="form-label">{{ 'BEDSIDE_SURVEY.PATIENT_INFO.EMAIL_LABEL' | translate }} <span class="required-asterisk">*</span></label>
            <input 
                type="email"
                class="form-input"
                formControlName="patientEmail" 
                [placeholder]="'BEDSIDE_SURVEY.PATIENT_INFO.EMAIL_PLACEHOLDER' | translate">
            <!-- <div class="error-message" *ngIf="surveyForm.get('patientEmail')?.touched && surveyForm.get('patientEmail')?.invalid">
                <span *ngIf="surveyForm.get('patientEmail')?.hasError('required')">{{ 'BEDSIDE_SURVEY.VALIDATION.REQUIRED' | translate }}</span>
                <span *ngIf="surveyForm.get('patientEmail')?.hasError('email')">{{ 'BEDSIDE_SURVEY.VALIDATION.INVALID_EMAIL' | translate }}</span>
            </div> -->
            </div>
        </div>

        <!-- Satisfaction Survey Section -->
        <div class="satisfaction-section">
            <h2 class="section-title">{{ 'BEDSIDE_SURVEY.SATISFACTION.TITLE' | translate }}</h2>
            
            <div *ngFor="let question of surveyQuestions; let i = index" class="question-container">
            <div class="question-text">
                <span class="question-number">{{ i + 1 }}.</span>
                <span class="question-content">{{ question.translationKey | translate }}</span>
            </div>
            
            <div class="rating-options">
                <button 
                *ngFor="let option of ratingOptions" 
                type="button"
                mat-stroked-button
                [class.selected]="isSelected(question.key, option.value)"
                (click)="selectRating(question.key, option.value)"
                class="rating-button">
                {{ option.translationKey | translate }}
                </button>
            </div>
            
            <mat-error 
                *ngIf="surveyForm.get(question.key)?.hasError('required') && surveyForm.get(question.key)?.touched"
                class="question-error">
                {{ 'BEDSIDE_SURVEY.VALIDATION.REQUIRED' | translate }}
            </mat-error>
            </div>
        </div>

        <!-- Additional Comments Section -->
        <div class="comments-section">
            <h2 class="section-title-2">{{ 'BEDSIDE_SURVEY.ADDITIONAL_COMMENTS.TITLE' | translate }}</h2>
            
            <textarea 
            class="form-textarea"
            formControlName="additionalComments" 
            rows="5"
            [placeholder]="'BEDSIDE_SURVEY.ADDITIONAL_COMMENTS.PLACEHOLDER' | translate">
            </textarea>
        </div>

        <!-- Submit Button -->
        <div class="submit-section">
            <button 
            mat-raised-button 
            type="submit" 
            class="submit-button"
            [disabled]="isSubmitting || surveyForm.invalid">
            {{ isSubmitting ? ('BEDSIDE_SURVEY.SUBMITTING' | translate) : ('BEDSIDE_SURVEY.SUBMIT_BUTTON' | translate) }}
            </button>
        </div>
        </form>
    </div>
    <div class="thank-you-message">
        {{ 'BEDSIDE_SURVEY.THANK_YOU' | translate }}
    </div>
</div>
<div  *ngIf="isMobileResolution" class="get-care-now-background-mobile">

</div>

